/** Tunables for the custom WiseFriend call surface. Adjust here, not in JSX. */

/** A new active speaker must stay active this long before the stage switches to them. */
export const ACTIVE_SPEAKER_PROMOTE_MS = 700
/** Once promoted, a speaker keeps the stage for at least this long. */
export const ACTIVE_SPEAKER_MIN_HOLD_MS = 3000
/** Above this many participants, video subscriptions are managed manually. */
export const AUTO_SUBSCRIBE_PARTICIPANT_THRESHOLD = 12
/** Never render more than this many video tiles at once. */
export const MAX_VISIBLE_TILES = 25
/** Layout breakpoints, in CSS pixels of the call surface container. */
export const TABLET_BREAKPOINT = 1024
export const MOBILE_BREAKPOINT = 768
/** Daily app-message type used to sync Inspire presenter actions to listeners. */
export const INSPIRE_SYNC_MESSAGE_TYPE = "wisefriend.inspire.sync"
/** Listener-side reconcile interval for Inspire visibility when realtime events are missed. */
export const INSPIRE_LISTENER_RECONCILE_INTERVAL_MS = 30000

/** How long an in-call device notice (blocked microphone, camera in use) stays before it hides itself. */
export const DEVICE_NOTICE_DISMISS_MS = 8000

/** A local mute/camera-off arriving later than this after the attendee's own toggle is attributed to a host. */
export const HOST_MEDIA_CHANGE_GRACE_MS = 1500
